const AUTH_REDIRECT_KEY = 'ml_auth_redirect';

export const redirectToLogin = ({ reason, returnTo } = {}) => {
  if (typeof window === 'undefined') return;
  if (window.location.pathname === '/login') return;

  if (sessionStorage.getItem(AUTH_REDIRECT_KEY)) return;
  sessionStorage.setItem(AUTH_REDIRECT_KEY, '1');

  const target = new URL('/login', window.location.origin);
  if (reason) {
    target.searchParams.set('reason', reason);
  }

  const currentPath = returnTo
    ? String(returnTo)
    : `${window.location.pathname}${window.location.search}${window.location.hash}`;

  if (currentPath && currentPath !== '/login') {
    target.searchParams.set('returnTo', currentPath);
  }

  window.location.assign(target.toString());
};

export const clearAuthRedirectFlag = () => {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(AUTH_REDIRECT_KEY);
};
